(function() {
    'use strict';

    angular.module('order')
        .controller('OrderSendUpsController', OrderSendUpsController);

    OrderSendUpsController.$inject = [
        '$state',
        '$q',
        '$timeout',
        'orderDataSrvc',
        'notificationSrvc',
        'orderSendMessagesConst',
        'orderProductDataSrvc',
        'orderProductByDeliveryDataSrvc',
        'orderDeliveriesDataSrvc',
        'orderDeliveryPackageDataSrvc',
        'printSrvc',
        'previewSrvc',
        'orderStatusConst',
        'orderSrvc',
        'errorNotificationSrvc',
        'downloadLinkSrvc',
        'couriersDataSrvc',
        'userStorageSrvc',
        'adminDataSrvc',
        'orderSourceConst',
        'orderShipmentCmdStatusConst'
    ];

    function OrderSendUpsController(
        $state, $q, $timeout, orderDataSrvc, notificationSrvc, orderSendMessagesConst, orderProductDataSrvc,
        orderProductByDeliveryDataSrvc, orderDeliveriesDataSrvc, orderDeliveryPackageDataSrvc, printSrvc, previewSrvc,
        orderStatusConst, orderSrvc, errorNotificationSrvc, downloadLinkSrvc, couriersDataSrvc, userStorageSrvc,
        adminDataSrvc, orderSourceConst, orderShipmentCmdStatusConst
    ) {
        var self = this;

        self.loading = true;

        self.canDisplayPointCollectionField = false;
        self.collectionPoints = [];
        self.adminData = {
            collection_point_suffix: ''
        }

        self.serverErrors = {
            nonFieldErrors: []
        };
        self.sendUpsData = {};
        self.orderData = {};

        self.orderProductCols = [{
            title: 'Podgląd',
            value: 'product_file.client_file_thumbnail',
            type: 'image',
            onClick: previewSrvc.previewOrderFile,
            helpers: [{
                elementClass: 'preflight-status-icon',
                tooltip: 'product_file.preflight_status.message',
                typeClass: 'product_file.preflight_status.class'
            }]
        }, {
            title: 'ID zlecenia',
            value: 'order_product',
            type: 'number',
            isEditable: false
        }, {
            title: 'Produkt',
            value: 'product_name',
            type: 'text',
            isEditable: false
        }, {
            title: 'Nakład',
            value: 'amount',
            type: 'number',
            isEditable: false
        }, {
            title: 'Waga',
            value: 'real_weight',
            type: 'number',
            required: true,
            minValue: 0,
            isEditable: true,
            isAlwaysShowInput: true,
            inputConditionField: 'amount'
        }];
        self.orderProductExtraActions = [{
            class: 'btn btn-xs',
            iconClass: 'fa fa-user',
            onClick: previewSrvc.getClientFile,
            isDisabled: previewSrvc.isClientFileNotAvailable,
            withLoading: true,
            title: 'Plik klienta'
        }, {
            class: 'btn btn-xs',
            iconClass: 'fa fa-search',
            onClick: previewSrvc.getResultFile,
            isDisabled: previewSrvc.isResultFileNotAvailable,
            withLoading: true,
            title: 'Plik wyjściowy'
        }, {
            class: 'btn btn-xs',
            iconClass: 'fa fa-user',
            onClick: previewSrvc.getClientCoverFile,
            isDisabled: previewSrvc.isClientCoverFileNotAvailable,
            displayCondition: previewSrvc.isClientCoverFileNotAvailable,
            withLoading: true,
            title: 'Plik okładki klienta'
        }, {
            class: 'btn btn-xs',
            iconClass: 'fa fa-search',
            onClick: previewSrvc.getCoverResultFile,
            isDisabled: previewSrvc.isCoverResultFileNotAvailable,
            displayCondition: previewSrvc.isCoverResultFileNotAvailable,
            withLoading: true,
            title: 'Plik okładki wyjściowy'
        }];
        self.orderProductRows = [];

        self.printedPackages = {};
        self.labelLoading = {};
        self.confirmLoading = {};

        self.updateWeight = updateWeight;

        self.isGenerateLabel = isGenerateLabel;
        self.generateLabel = generateLabel;
        self.isLabelLoading = isLabelLoading;
        self.isAllegroSource = isAllegroSource;
        self.isShipmentInProgress = isShipmentInProgress;
        self.longPoll = longPoll;
        self.longPollInpost = longPollInpost;

        self.isConfirmDeliveryPackage = isConfirmDeliveryPackage;
        self.confirmDeliveryPackage = confirmDeliveryPackage;
        self.isConfirmLoading = isConfirmLoading;
        self.isPrintLabel = isPrintLabel;
        self.printLabel = printLabel;
        self.isInProduction = isInProduction;
        self.isPrintAvailable = isPrintAvailable;
        self.getPrintBtnName = getPrintBtnName;
        self.onCollectionPointChange = onCollectionPointChange;

        self.getOrderCard = orderSrvc.getOrderCard;

        activate();

        function activate() {
            getOrder();
        }

        function getOrder() {
            self.loading = true;

            return orderDataSrvc.sendUpsGet({
                pk: $state.params.pk
            }).$promise.then(
                function(response) {
                    self.orderData = response;
                    if (!self.isInProduction()) {
                        $state.go('layout.order.send');
                        notificationSrvc.notification("error", orderSendMessagesConst.orderStatusError);
                    }

                    $q.all([getAdmin(), getCollectionPoints()])
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors.nonFieldErrors = response.data;
                }
            ).finally(
                function(response) {
                    self.loading = false;
                    return response;
                }
            );
        }

        function updateWeight(row) {
            return orderProductByDeliveryDataSrvc.sendUpsUpdateRealWeight({
                pk: row.pk
            }, {
                real_weight: row.real_weight
            }).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", orderSendMessagesConst.orderProductUpdateWeightOk);
                    return response;
                },
                function(reason) {
                    notifyErrors(reason, orderSendMessagesConst.orderProductUpdateWeightError);
                }
            );
        }

        function isGenerateLabel(deliveryAddress) {
            return !self.orderData.is_ups_self_pickup && deliveryAddress.delivery_packages.filter(function(item) {
                return item.tracking_number;
            }).length !== deliveryAddress.delivery_packages.length;
        }

        function generateLabel(deliveryAddress) {
            self.labelLoading[deliveryAddress.pk] = true;

            return orderDeliveriesDataSrvc.generateLabel({
                pk: deliveryAddress.pk
            }).$promise.then(
                function(response) {
                    getOrder();

                    if (isAllegroSource(self.orderData)) {
                        longPoll(5000);
                        notificationSrvc.notification("success", orderSendMessagesConst.orderShipmentCmdCreated);

                    } else if (self.orderData.is_inpost_delivery_service) {
                        longPollInpost(5000);
                        notificationSrvc.notification("success", orderSendMessagesConst.orderShipmentInpostCreated);

                    } else {
                        notificationSrvc.notification("success", orderSendMessagesConst.orderAddressGenaratedLabel);
                        self.labelLoading[deliveryAddress.pk] = false;
                    }

                    return response;
                },
                function(reason) {
                    self.labelLoading[deliveryAddress.pk] = false;
                    notifyErrors(reason, orderSendMessagesConst.generateLabelError);
                }
            );
        }

        function isLabelLoading(deliveryAddress) {
            return self.labelLoading[deliveryAddress.pk];
        }

        function isConfirmDeliveryPackage(deliveryPackage) {
            if (self.orderData.is_ups_self_pickup) {
                return !deliveryPackage.is_packed;
            } else {
                return !deliveryPackage.is_packed && deliveryPackage.tracking_number;
            }
        }

        function confirmDeliveryPackage(deliveryPackage) {
            self.confirmLoading[deliveryPackage.pk] = true;

            return orderDeliveryPackageDataSrvc.update({
                pk: deliveryPackage.pk
            }, {
                is_packed: true
            }).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", orderSendMessagesConst.orderPackageConfirm);
                    deliveryPackage.is_packed = true;
                    self.confirmLoading[deliveryPackage.pk] = false;
                    return response;
                },
                function(reason) {
                    self.confirmLoading[deliveryPackage.pk] = false;
                    notifyErrors(reason, orderSendMessagesConst.confirmPackageError);
                }
            );
        }

        function isConfirmLoading(deliveryPackage) {
            return self.confirmLoading[deliveryPackage.pk];
        }

        function isPrintLabel(deliveryPackage) {
            if (self.orderData.is_ups_self_pickup) {
                return false;
            } else {
                return deliveryPackage.is_packed && deliveryPackage.tracking_number;
            }
        }

        function printLabel(deliveryPackage) {
            return orderDeliveryPackageDataSrvc.get({
                pk: deliveryPackage.pk
            }).$promise.then(
                function(response) {
                    self.printedPackages[deliveryPackage.pk] = true;
                    if(response.is_inpost_delivery) {
                        printSrvc.printAlt(response.label_image, 397, 559);

                    } else if(response.is_gls_delivery || response.is_self_pickup_delivery || self.isAllegroSource()) {
                        printSrvc.printAlt(response.label_image, 339, 566);

                    } else {
                        printSrvc.printAlt(response.label_image);
                    }

                    return response;
                }
            );
        }

        function notifyErrors(response, defaultMsg) {
            var errors = [];

            angular.forEach(response.data, function(value, key) {
                if (angular.isArray(value)) {
                    errors = errors.concat(value);
                } else {
                    errors.push(value);
                }
            });

            if (errors.length) {
                for (var i = 0; i < errors.length; ++i) {
                    notificationSrvc.notification("error", errors[i]);
                }
            } else {
                notificationSrvc.notification("error", defaultMsg);
            }
        }

        function isInProduction() {
            return self.orderData.status === orderStatusConst.in_production.value;
        }

        function isPrintAvailable(deliveryPackage) {
            return !self.printedPackages[deliveryPackage.pk];
        }

        function getPrintBtnName(deliveryPackage){
            if (!self.printedPackages[deliveryPackage.pk]){
                return "| Drukuj"
            } else {
                return "| Drukuj ponownie"
            }
        }

        function isCanDisplayPointCollectionField() {
            var isLabelsGenerated = false;
            for (var i = 0; i < self.orderData.delivery_addresses.length; i++) {
                if(self.orderData.delivery_addresses[i].ups_tracking_number !== null){
                    isLabelsGenerated = true;
                }
            }
            return self.orderData.is_gls_delivery_service && !isLabelsGenerated && self.collectionPoints.length > 1;
        }

        function getCollectionPoints(){
            self.loading = true;
            couriersDataSrvc.getCollectionPoints().$promise.then(
                function(response) {
                    self.collectionPoints = response;
                    self.canDisplayPointCollectionField = isCanDisplayPointCollectionField();
                    return response;
                }
            )
            .finally(
                function(response) {
                    self.loading = false;
                    return response;
                }
            );
        }

        function onCollectionPointChange() {
            adminDataSrvc.update(
                {pk: self.adminData.pk},
                {collection_point_suffix: self.adminData.collection_point_suffix}
            ).$promise.then(
                function (response){
                    return response;
                }
            )
        }

        function getAdmin() {
            self.loading = true;
            var user = userStorageSrvc.getUser();
            return adminDataSrvc.getAdminByUsername(
                {username: user.username}
            ).$promise.then(function(response) {
                self.adminData = response;
                if (self.adminData.collection_point_suffix == null){
                    self.adminData.collection_point_suffix = '';
                }
                return response;

            }).finally(function(response) {
                self.loading = false;
                return response;
            });
        }

        function isAllegroSource(){
            return self.orderData.source === orderSourceConst.allegro.value
        }

        function isShipmentInProgress(deliveryAddress){
            return deliveryAddress.detail &&
                deliveryAddress.detail.cmd.status === orderShipmentCmdStatusConst.in_progress.value
        }

        function longPoll(interval){
            return orderDataSrvc.sendUpsGet({pk: $state.params.pk}).$promise.then(
                function(response) {
                    self.orderData = response;

                    var continuePolling = false;

                    for (var i = 0; i < self.orderData.delivery_addresses.length; i++) {
                        var delivery_address = self.orderData.delivery_addresses[i];

                        if (isShipmentInProgress(delivery_address) || !delivery_address.ups_tracking_number){
                            continuePolling = true;
                            break;
                        }
                    }

                    if (continuePolling) {
                        $timeout(function () {
                            longPoll(interval);
                        }, interval);
                    } else {
                        self.orderData.delivery_addresses.forEach(function(delivery_address){
                            self.labelLoading[delivery_address.pk] = false;
                        });
                    }
                }
            );
        }

        function longPollInpost(interval) {
            return orderDataSrvc.sendUpsGet({pk: $state.params.pk}).$promise.then(
                function(response) {
                    self.orderData = response;

                    var continuePolling = false;

                    for (var i = 0; i < self.orderData.delivery_addresses.length; i++) {
                        var delivery_address = self.orderData.delivery_addresses[i];

                        for (var package_i = 0; i < delivery_address.delivery_packages.length; package_i++) {
                            var delivery_package = delivery_address.delivery_packages[package_i];

                            if (!delivery_package.tracking_number) {
                                continuePolling = true;
                                break;
                            }
                        }
                    }

                    if (continuePolling) {
                        $timeout(function () {
                            longPollInpost(interval);
                        }, interval);
                    } else {
                        self.orderData.delivery_addresses.forEach(function(delivery_address){
                            self.labelLoading[delivery_address.pk] = false;
                        });

                        notificationSrvc.notification("success", orderSendMessagesConst.orderAddressGenaratedLabel);
                    }
                }
            );
        }
    }
})();
